import React, { useState } from "react";

import A from "../A.png";
import B from "../B.png";
import "./NavLinks.css";

const NavLinks = (props) => {
  const [logo, setLogo] = useState(A);

  const logoOverHandler = () => setLogo(B);

  const logoLeaveHandler = () => setLogo(A);

  return (
    <ul
      className="nav-links"
      onMouseOver={logoOverHandler}
      onMouseLeave={logoLeaveHandler}
    >
      <li>
        <h1 className="main-navigation__title">
          <a
            href="https://abhinavbhardwaj.in"
            target="_blank"
            rel="noopener noreferrer"
          >
            About{" "}
            <img
              src={logo}
              style={{ height: "6vmin", width: "6vmin" }}
              className=" rounded"
              alt="AbhinavBhardwaj Logo"
            />{" "}
            Abhinav
          </a>
        </h1>
      </li>
    </ul>
  );
};

export default NavLinks;
